/**
 * Whitelist de rotas que, com a chave OFFLINE_EDGE ligada e o Barid em modo OFFLINE, sao atendidas pelo Barid
 * local (`/offline/local/...`) em vez da nuvem. Specs/wazir/offline/00-base.md §14 item 5.
 *
 * VAZIA na fase 0: nenhuma rota do Wazir muda de comportamento. Cada modulo (Pessoas, Licencas, Financeiro,
 * Caixa) acrescenta as suas aqui, junto da rota local registrada no Barid (`OfflineLocalRouteRegistry`).
 */
export interface OfflineRoute {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  /** Casa com o caminho RELATIVO a API, sem query string e sem barra inicial (ex.: `billing/cashier/open`). */
  pattern: RegExp;
}

export const OFFLINE_ROUTE_WHITELIST: ReadonlyArray<OfflineRoute> = [];

/** Prefixo das rotas locais do Barid. */
export const OFFLINE_LOCAL_PREFIX = '/offline/local/';

export function findOfflineRoute(
  method: string,
  relativePath: string,
  whitelist: ReadonlyArray<OfflineRoute> = OFFLINE_ROUTE_WHITELIST
): OfflineRoute | null {
  const upper = method.toUpperCase();
  return whitelist.find((route) => route.method === upper && route.pattern.test(relativePath)) ?? null;
}
